import { useEffect, useState } from "react";

export const useGoogleAnalyticsHandler = (requestData) => {

    const [initialized, setInitialized] = useState(false)

    useEffect(() => {
        if (!window.jostensGASY25Enabled) return;

        const scriptId = 'google-analytics-script';

        // Return if the page is not initialized yet with proper parameters
        if(!requestData?.customerNumber) return;

        // Return if GA Script is already injected.
        if(document.querySelector(`#${scriptId}`)) return;

        const googleAnalyticsScriptElement = document.createElement('script');
        googleAnalyticsScriptElement.src = '/apps/jcom/s4/src/js-lib/jostens-ga-tracking/jostens-ga-tracking.js';
        googleAnalyticsScriptElement.setAttribute("data-ot-ignore", "data-ot-ignore");
        googleAnalyticsScriptElement.setAttribute("id", scriptId);

        googleAnalyticsScriptElement.onload = () => {
            initJostensGASY25Engine(requestData.customerNumber)
            pageLoadTrackingGASY25(requestData)
            setInitialized(true)
        };
        googleAnalyticsScriptElement.onerror = (error) => {
            console.error('Failed to load GA tracking script:', error);
        };

        document.head.appendChild(googleAnalyticsScriptElement);
    }, [requestData?.customerNumber]);

    function initJostensGASY25Engine(customerNumber) {
        if (typeof window.jostensGaTracking !== "undefined") {
            window.jostensGaTracking.init({
                customerId: customerNumber,
                gaPageType: window.isSchoolStorePage 
                    ? window.jostensGaTracking.gaPageTypeList.schoolStorePage
                        : window.jostensGaTracking.gaPageTypeList.productListingPage,
                publishedCatalogId: '-',
                publishedProductId: '-',
                sourceCatalogType: '-'
            })
        }
    }

    function pageLoadTrackingGASY25({ catalogOsrList }) {
        if (typeof window.jostensGaTracking !== "undefined") {
            window.jostensGaTracking.trackEvent({
                event: window.isSchoolStorePage 
                    ? window.jostensGaTracking.gaEventNameList.schoolStorePage.schoolStorePageLoad
                        : window.jostensGaTracking.gaEventNameList.productListingPage.productListingPageLoad,
                client: {
                    _resolveFields: {
                        businessUnit: { catalogOsrList },
                        productLine: { catalogOsrList }
                    }
                }
            })
        }
    }

    function selectItemTrackingGASY25(catalogOsr, clickText, itemName, actionType, 
                                        categoryName='', contentName='', contentType='') {
        if (typeof window.jostensGaTracking !== "undefined") {
            window.jostensGaTracking.trackEvent({
                event: window.isSchoolStorePage
                    ? window.jostensGaTracking.gaEventNameList.schoolStorePage.selectItem
                        : window.jostensGaTracking.gaEventNameList.productListingPage.selectItem,
                client: {
                    _resolveFields: {
                        businessUnit: { catalogOsr },
                        productLine: { catalogOsr }
                    },
                    clickText, itemName, actionType, categoryName, contentName, contentType
                }
            })
        }
    }
    
    return (initialized) ? ({
        selectItemTrackingGASY25,
        catalogOSR: requestData?.catalogOsr,
        customerNumber: requestData?.customerNumber
    }) : null
}